import { createSelector } from 'reselect'
import { getFlag } from 'helpers/featureFlags/provider'

const getFeatureFlagHash = state => state.user.featureFlagsHash

const featureFlagsSelector = featureFlagsKeys => createSelector(
	[ getFeatureFlagHash ],
	() => featureFlagsKeys.reduce((accum, key) => {
		accum[key] = getFlag(key)
		return accum
	}, {})
)

export default featureFlagsSelector
